export default __webpack_public_path__ + "static/media/7.44981c01.jpg";